import { render, staticRenderFns } from "./wheel.vue?vue&type=template&id=ef1c41be&scoped=true"
import script from "./wheel.vue?vue&type=script&lang=js"
export * from "./wheel.vue?vue&type=script&lang=js"
import style0 from "./wheel.vue?vue&type=style&index=0&id=ef1c41be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1c41be",
  null
  
)

export default component.exports